module.exports = __webpack_public_path__ + "static/fullsignal-logo-fc6ea4f90fac734cc38a87e4aacf2049.svg";